module.exports = __webpack_public_path__ + "img/logo.e8009299.png";